export const breakpoints = {
  values: {
    xs: 0, // extra-small
    sm: 0, // small
    md: 0, // medium
    lg: 1198, // large
    xl: 1440, // extra-large
  },
} as const;
